import { render, staticRenderFns } from "./LiveNavigation.vue?vue&type=template&id=6c21c90f&scoped=true&"
import script from "./LiveNavigation.vue?vue&type=script&lang=js&"
export * from "./LiveNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c21c90f",
  null
  
)

export default component.exports